module.exports = __webpack_public_path__ + "img/1.d2763c1f.jpg";